var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function PageRichPhotoBlock(el) {
  this.$el = $(el);

  this.$el.on('click', function() {
    this.$el.toggleClass('open');
  }.bind(this));
}

module.exports = PageRichPhotoBlock;